import {
  SET_DISP_TAB,
  SET_DISP_DATE,
  SET_SELECT_SEQUENCE_ID,
  SET_JOB_LIST,
  SET_SELECT_JOB,
  SET_CHAR_CODE,
  SET_INIT_UPLOAD_STATE,
  SET_ERR_DISP_DATE,
  SET_ERROR_FILE_ID,
  SET_ADDITIONAL_ITEMS_ID,
} from '../actions/UploadAction';
import { UPLOAD_COMPANY_TAB, CHAR_CODE } from '../../common/const';

const initState = {
  // 表示タブ
  dispTab: UPLOAD_COMPANY_TAB.SETTING,
  // 表示年月日
  dispDate: null,
  // 選択シーケンスID
  selectSequenceId: null,
  // ジョブ一覧
  jobList: [],
  // 選択ジョブ
  selectJob: {},
  // 文字コード
  charCode: CHAR_CODE.SJIS,
  // 年月日エラーフラグ
  errDispDate: false,
  // 取引情報ファイルIDリスト
  additionalItemsIdList: [],
  // エラーファイルIDリスト
  errorFileIdList: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case SET_DISP_TAB:
      return { ...state, dispTab: action.dispTab };
    case SET_DISP_DATE:
      return { ...state, dispDate: action.dispDate };
    case SET_SELECT_SEQUENCE_ID:
      return { ...state, selectSequenceId: action.selectSequenceId };
    case SET_JOB_LIST:
      return { ...state, jobList: action.jobList };
    case SET_SELECT_JOB:
      return { ...state, selectJob: action.selectJob };
    case SET_CHAR_CODE:
      return { ...state, charCode: action.charCode };
    case SET_INIT_UPLOAD_STATE:
      return { ...initState };
    case SET_ERR_DISP_DATE:
      return { ...state, errDispDate: action.errDispDate };
    case SET_ADDITIONAL_ITEMS_ID:
      return { ...state, additionalItemsIdList: action.additionalItemsIdList };
    case SET_ERROR_FILE_ID:
      return { ...state, errorFileIdList: action.errorFileIdList };
    default:
      return state;
  }
};
